export function articleToStreamText(article) {
  const lines = [
    `# ${article?.title || "未命名公众号文章"}`,
    "",
    `摘要：${article?.summary || "这篇文章由章法 AI 生成，建议发布前人工复核事实和表达。"}`,
    ""
  ];

  for (const section of article?.sections || []) {
    lines.push(`## ${section.heading || "正文"}`, "");
    for (const paragraph of section.paragraphs || []) {
      if (String(paragraph).trim()) lines.push(String(paragraph).trim(), "");
    }
  }

  return lines.join("\n").trimEnd();
}

export function articleFromStreamText(text, options = {}) {
  const normalized = normalizeLines(text);
  const lines = normalized.split("\n");
  const titleLineIndex = lines.findIndex((line) => /^#\s+/.test(line));
  const fallbackTitle = options.fallbackTitle || "正在生成文章";
  const title = titleLineIndex === -1
    ? firstContentLine(lines) || fallbackTitle
    : lines[titleLineIndex].replace(/^#\s+/, "").trim() || fallbackTitle;

  let summary = "";
  const sections = [];
  let currentSection = null;
  let paragraphLines = [];

  function flushParagraph() {
    const paragraph = paragraphLines.join(" ").trim();
    if (paragraph) {
      if (!currentSection) currentSection = { id: `sec-${sections.length + 1}`, heading: "正文", paragraphs: [] };
      currentSection.paragraphs.push(paragraph);
    }
    paragraphLines = [];
  }

  function flushSection() {
    flushParagraph();
    if (currentSection?.paragraphs.length) sections.push(currentSection);
    currentSection = null;
  }

  for (let index = titleLineIndex === -1 ? 0 : titleLineIndex + 1; index < lines.length; index += 1) {
    const line = lines[index].trim();
    if (!line) {
      flushParagraph();
      continue;
    }

    const summaryMatch = line.match(/^摘要[:：]\s*(.+)$/);
    if (summaryMatch && !currentSection) {
      summary = summaryMatch[1].trim();
      continue;
    }

    const headingMatch = line.match(/^##\s+(.+)$/);
    if (headingMatch) {
      flushSection();
      currentSection = {
        id: `sec-${sections.length + 1}`,
        heading: headingMatch[1].trim() || `小节 ${sections.length + 1}`,
        paragraphs: []
      };
      continue;
    }

    if (!summary && !currentSection) {
      summary = line;
      continue;
    }

    paragraphLines.push(line);
  }

  flushSection();

  return {
    id: `article-${Date.now()}`,
    title,
    titleCandidates: [title],
    summary: summary || "正在生成摘要...",
    sections: sections.length ? sections : [{ id: "sec-1", heading: "正文", paragraphs: ["正在生成正文..."] }],
    imageSuggestions: [],
    quoteCandidates: [],
    sourceWarnings: []
  };
}

export function* chunkText(text, size = 12) {
  const source = String(text || "");
  for (let index = 0; index < source.length; index += size) {
    yield source.slice(index, index + size);
  }
}

function normalizeLines(value) {
  return String(value || "")
    .replace(/\r/g, "\n")
    .replace(/[ \t]+\n/g, "\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
}

function firstContentLine(lines) {
  return lines.map((line) => line.trim()).find(Boolean) || "";
}
